<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <h4 class="card-title" style="font-weight:bold;">Gestion des Livreurs</h4>
            </template>
            
            <table class="table">
              <thead>
                <tr> 
                  <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">#</th>
                  <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Status du livreur</th>
                  <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Noms et Prénoms</th>
                  <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Contacts</th>
                  <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Actions</th>
                </tr>
              </thead>

              <tbody v-for="user in users" :key="user.id">
                
                <tr v-if="user.role == '1' ">
                    <td>{{ users.indexOf(user) + 1 }}</td>
                    <td>
                      <select class="form-control" v-model="user.statusLivreur" id="" disabled>
                          <option value="0">Desactivé</option>
                          <option value="1">Activé</option>
                      </select>
                    </td>
                    <td>{{ user.name }}</td>
                    <td>{{ user.number }}</td>
                    <td>
                      <router-link :to="{name: 'Editer_livreur', params: { id: user.id }}" class="btn btn-default">
                        <i class="fa fa-pencil" aria-hidden="true" style="color:blue; font-weight:bold"></i>
                      </router-link>
                      <router-link :to="{path: '/Voir_livreur/' + user.id }" v-bind:tooltip="user.id"  class="btn btn-default">
                        <i class="fa fa-eye" aria-hidden="true" style="color:#FFAB0E; font-weight:bold"></i>
                      </router-link>
                    </td>
                </tr>
                
              </tbody>
            </table>

          </card>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import { db } from '../../main';
  export default {
  name: "Livreurs",
  data() {
    return {
      users: []
    };
  },
  
  created() {
    db.ref("users")
      .once("value")
      .then(dataSnapshot => {
        const itemsArray = [];
        dataSnapshot.forEach(childSnapshot => {
          const childData = childSnapshot.val();
          itemsArray.push({
            id: childData.id,
            role: childData.role,
            statusLivreur: childData.statusLivreur,
            name: childData.name,
            number: childData.number,
            email: childData.email,
          });
        });
        this.users = itemsArray;
      });
    },

  };

</script>

<style>
    .btn-primary {
        margin-right: 12px;
    }
</style>

